// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a4a794db","703":"5a2c0727","787":"d3fc8719"}[chunkId] + ".chunk.js";
};